import Resource from './Resource'

class ContractType extends Resource {}

export default ContractType
